export const SENDER_COMPLAINT_LIST_SCREEN = 'SenderComplaintList';

export function parseAllowedScreensFromPermissionsResponse(res: any): Set<string> {
    const ok = res && (res.isSuccess === true || res.IsSuccess === true);
    if (!ok) {
        return new Set();
    }
    const list = (res.result || res.Result || []) as Array<{
        screenKey?: string;
        ScreenKey?: string;
        isAllowed?: boolean;
        IsAllowed?: boolean;
    }>;
    return new Set(
        list
            .filter(x => x.isAllowed === true || (x as any).IsAllowed === true)
            .map(x => (x.screenKey || (x as any).ScreenKey) as string)
    );
}

export function canProcessComplaints(userRole: number, allowedScreens: Set<string> | null): boolean {
    if (userRole === 16 || userRole === 3) {
        return true;
    }
    if (userRole === 4) {
        return allowedScreens !== null && allowedScreens.has(SENDER_COMPLAINT_LIST_SCREEN);
    }
    return false;
}
